<template>
  <div class="container">
    <div class="row">


    <label class="control-label" v-if="this.getKey('tipo_dec') === 'Anual'">
      INGRESOS NETOS DEL DECLARANTE, PAREJA Y/O DEPENDIENTES ECONÓMICOS (ENTREL EL 1 DE ENERO Y EL 31 DE DICIEMBRE DEL AÑO INMEDIATO ANTERIOR)
    </label>

    <label class="control-label" v-if="this.getKey('tipo_dec') === 'Final'">
      INGRESOS NETOS DEL AÑO EN CURSO A LA FECHA DE CONCLUSIÓN DEL EMPLEO, CARGO O COMISIÓN DEL DECLARANTE, PAREJA Y/O DEPENDIENTES ECONÓMICOS
    </label>

     <label for="" class="control-label">Requisite cantidades libres de impuestos, <strong>SIN CENTAVOS Y SIN CEROS A LA IZQUIERDA.</strong></label>

    </div>

      <div class="row" v-if="this.getKey('tipo_dec') === 'Inicial'">
        <div class="form-group col-md-12">
          <label class="control-label">
            ¿TE DESEMPEÑASTE COMO SERVIDOR PÚBLICO OBLIGADO A PRESENTAR DECLARACIÓN DE SITUACIÓN PATRIMONIAL EN EL AÑO INMEDIATO ANTERIOR?
          </label>
          <p-radio class="d-inline-block" v-model="item_entes22.bandera" label="1">Si</p-radio>
          <p-radio class="d-inline-block" v-model="item_entes22.bandera" label="0">No</p-radio>
        </div>
      </div>
        <div v-if="item_entes22.bandera == '1' || this.getKey('tipo_dec') === 'Anual' || this.getKey('tipo_dec') === 'Final'">
           <div class="row" v-if="this.getKey('tipo_dec') === 'Inicial'">
            <div class="form-group col-md-4">
              <label class="control-label">Inicio del periodo</label>
              <div class="form-group">
                <el-date-picker name="fecha_inicio_periodo" type="date" v-model="item_entes22.fecha_inicio_periodo" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker>
              </div>
            </div>
            <div class="form-group col-md-4">
              <label class="control-label">Fin del periodo</label>
              <div class="form-group">
                <el-date-picker name="fecha_fin_periodo" type="date" v-model="item_entes22.fecha_fin_periodo" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker>
              </div>
            </div>
          </div>




      <!--
        <p>(Nota: si sus ingresos fueron en moneda extranjera, conviértalos a moneda nacional asentando en el apartado de observaciones y aclaraciones el tipo de cambio utilizado)</p>
        -->
      <div class="row">
        <p>I.Ingresos netos recibidos durante el tiempo en el que se desempeño como servidor público en el año inmediato anterior.</p>
        <div class="col-md-10 form-group" v-if="this.plantilla != null">
         <!-- <label class="control-label">
          <strong>El dato precargado de tus ingresos es información proporcionada por el área de recursos humanos: $ {{this.plantilla.ingreso_anual_neto | formatPrice }}, si el dato no corresponde, por favor captura el dato correcto en la fracción I.
         </strong></label> -->
         <label class="control-label">
         Te compartimos el <b>monto de tus ingresos</b> <strong> $ {{this.plantilla.ingreso_anual_neto | formatPrice }} </strong>, proporcionado por el área de Recursos Humanos: si es correcta, registra la cantidad en el <b>punto I</b>, de existir error captura el monto correspondiente.</label>
          <!-- <currency style="text-align: right" name="plantilla" v-model="plantilla.ingreso_anual_neto" sign="" aria-required="true" aria-invalid="true" disabled></currency>
          <small class="text-danger">{{ errors.first('plantilla')}}</small> -->
        </div>
        <div class="col-md-10 form-group">
          <label class="control-label" v-if="this.getKey('tipo_dec') === 'Final'">
            I. Remuneración neta del año en curso a la fecha de conclusión del empleo, cargo o comisión del declarante por su cargo publico(por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)(cantidades netas después de impuestos)
          </label>
          <label class="control-label" v-else>
            I. Remuneración neta del declarante, recibida durante el perdiodo que se desempeño como servidor público en el año inmediato anteior (por concepto de sueldos, honorarios, compensaciones, bonos, aguinaldos y otras prestaciones)(cantidades netas después de impuestos)
          </label>
        </div>
        <div class="col-md-2 form-group">
          <currency style="text-align: right" name="ant_sub_12" v-validate="'required|min:1|min_value:1'" v-model="item_entes22.ant_sub_12" sign="" aria-required="true" aria-invalid="true"></currency>
          <small class="text-danger">{{ errors.first('ant_sub_12')}}</small>
        </div>
        <p>II. Otros ingresos anuales netos del declarante (suma del II.1 al II.5).</p>
        <div class="col-md-12 form-group">
          <label class="control-label">
            II. 1 Por actividad industrial, comercial y/o comercial (Deduzca impuestos)
            Especifica nombre o razón social y tipo de negocio
          </label>
          <div class="row">
            <div class="col-md-4 form-group">
              <input class="form-control" type="text" v-model="item_entes22.ant_actividad_comercial" placeholder="Nombre o razón social">
            </div>
            <div class="col-md-4 form-group">
              <input class="form-control" type="text" v-model="item_entes22.tiponegocio" placeholder="Tipo de negocio">
            </div>
            <div class="col-md-4 form-group">
              <currency name="ant_actividad_comercial_cantidad" v-model="item_entes22.ant_actividad_comercial_cantidad" sign=""></currency>
              <small class="text-danger">{{ errors.first('ant_actividad_comercial_cantidad')}}</small>
            </div>
          </div>
        </div>
      </div>
      <!---->
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 2 Por actividad financiera (rendimientoso ganancias) (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            Tipo de instrumento que generó el rendimiento o ganancia
            <el-select  class="select-default" v-model="item_entes22.ant_actividad_financiera" width="100%" name="ant_actividad_financiera"  >
              <el-option v-for="option in tipoinst" class="select-default" :value="option.id" :label="option.valor" :key="option.id">
              </el-option>
            </el-select>
            <div v-if="item_entes22.ant_actividad_financiera ==7">
              <label class="control-label">
                Otro Sector
              </label>
              <input class="form-control" type="text" name="otroSector" v-model="item_entes22.otro_ant_actividad_financiera" placeholder="Otro tipo de instrumento" />
            </div>
          <!--
            <input class="form-control" type="text" v-model="item_entes22.ant_actividad_financiera" placeholder="Descripción">
          -->
          </div>
          <div class="col-md-4 form-group">
            <currency name="ant_actividad_financiera_cantidad" v-model="item_entes22.ant_actividad_financiera_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_actividad_financiera_cantidad')}}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 3 Por servicios profesionales, consejos, y/o asesorías Especifica el tipo de servicio y el contratante (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <input class="form-control" type="text" v-model="item_entes22.ant_servicios_profecionales" placeholder="Tipo de servicio prestado">
          </div>
          <div class="col-md-4 form-group">
            <currency name="ant_servicios_profecionales_cantidad" v-model="item_entes22.ant_servicios_profecionales_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_servicios_profecionales_cantidad')}}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 4 Por enajenación de bienes (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
           <!-- <input class="form-control" type="text" v-model="item_entes22.ant_arrendamientos" placeholder="Descripción">-->

          <el-select  class="select-default" v-model="item_entes22.tipo_bien_enajenacion" width="100%" name="cat_tipo_bien_enajenacion"  >
              <el-option v-for="option in tipobienen" class="select-default" :value="option.id" :label="option.valor" :key="option.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 form-group">
            <currency name="ant_arrendamientos_cantidad" v-model="item_entes22.ant_arrendamientos_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_arrendamientos_cantidad')}}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          II. 5 Otros ingresos no considerados a los anteriores (Después de impuestos)
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <input class="form-control" type="text" v-model="item_entes22.otros_ingresos" placeholder="Descripción">
          </div>
          <div class="col-md-4 form-group">
            <currency name="ant_otros_cantidad" v-model="item_entes22.ant_otros_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_otros_cantidad')}}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
        </label>
        <div class="row">
          <div class="col-md-8 form-group" style="text-align: right">
            Subtotal:
          </div>
          <div class="col-md-4 form-group">
            <currency v-model="calculo1" sign="" readonly></currency>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
        </label>
        <div class="row">
          <div class="col-md-8 form-group" style="text-align: right">
            Suma Remuneración anual y Subtotal:
          </div>
          <div class="col-md-4 form-group">
            <currency name="ant_arrendamientos_cantidad" v-model="calculo2" sign="" readonly></currency>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          A. INGRESO ANUAL NETO DEL DECLARANTE
        </label>
        <currency v-model="item_entes22.ant_suma_12" sign="" readonly></currency>
        <small class="text-danger">{{ errors.first('ant_neto_declarante')}}</small>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
          B. INGRESO ANUAL NETO DEL CÓNYUGE CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS (DEDUZCA IMPUESTOS)
          ESPECIFICA
        </label>
        <div class="row">
          <div class="col-md-8 form-group">
            <input class="form-control" type="text" v-model="item_entes22.ant_neto_conyugue" placeholder="Descripción">
          </div>
          <div class="col-md-4 form-group">
            <currency name="ant_neto_conyugue_cantidad" v-model="item_entes22.ant_neto_conyugue_cantidad" sign=""></currency>
            <small class="text-danger">{{ errors.first('ant_neto_conyugue_cantidad')}}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12 form-group">
        <label class="control-label">
        </label>
        <div class="row">
          <div class="col-md-8 form-group" style="text-align: right">
            C. TOTAL DE INGRESOS ANUALES NETOS DEL DECLARANTE, CÓNYUGE, CONCUBINA O CONCUBINARIO
            Y/O DEPENDIENTES ECONÓMICOS:
          </div>
          <div class="col-md-4 form-group">
            <currency v-model="calculo3" sign="" readonly></currency>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker,
    InputNumber
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      [InputNumber.name]: InputNumber,
      Domicilio
    },
    props: ["data"],
    data() {
      return {
        ip_id: null,
        add_item: false,
        edit_item: null,
        tipo:'',
        modelValidations: {
          nombre: {
            min: 5
          },
          email: {
            required: true,
            email: true
          }
        },
        entes: null,
        tipoinst:[],
        tipobienen:[],
         //monedas: [],
        plazos: [],
        actividades: [],
        sectores: null,
        n_domicilio: null,
        //monedas: [],
        entidadFed: null,
        municipios: null,
        localidades: null,
        localidad: null,
        //paises: null,
        isnum: null,
        suma3: 0,
        /* Lista de Bienes */
        plantilla:{
          ingreso_anual_neto: ""
        },
        item_entes22: {
          ant_suma_12: 0,
          ant_actividad_comercial_cantidad: 0,
          ant_actividad_financiera_cantidad: 0,
          ant_servicios_profecionales_cantidad: 0,
          ant_arrendamientos_cantidad: 0,
          ant_ingreso_anual_cantidad: 0,
          ant_ingreso_anual_conyugue_cantidad: 0,
          ant_neto_conyugue_cantidad: 0,
          acciones: "",
          bandera: '0',
          rfc_quien_adquirio: "",
          ingreso_bruto_anual: "",
          moneda_id: 97,
          unidad_temporal_id: '',
          duracion_frecuencia: '',
          fecha_transaccion: '',
          pais_id: "",
          entidad_federativa_id: "",
          municipio_id: "",
          localidad_id: "",
          colonia: "",
          cp: "",
          numExt: "",
          numInt: "",
          vialidad_nom_vial: "",
          vialidad_tipo_vial: "",
          observaciones: ""
        },
        list_entes: [],
        fields_list: [{
            key: "acciones",
            label: "Acciones",
            tdClass: "text-center"
          },
          {
            key: "nombre_denominacion_razon_social",
            label: "Denominación o razón social",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "rfc",
            label: "RFC",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "curp",
            label: "CURP",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "sector_industria_id",
            label: "Sector",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "tipo_actividad_servicio_id",
            label: "Tipo de actividad ",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "descripcion_actividad_servicio",
            label: "Descripción de la actividad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "ingreso_bruto_anual",
            label: "Ingreso bruto anual ",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
          {
            key: "moneda_id",
            label: "Moneda",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "duracion_frecuencia",
            label: "Duración / Frecuencia",
            tdClass: "text-center",
            formatter: 'emptyFields'
          },
          {
            key: "unidad_temporal_id",
            label: "Unidad temporal",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "fecha_transaccion",
            label: "Fecha de transacción",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "observaciones",
            label: "Observaciones",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "pais_id",
            label: "País",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "entidad_federativa_id",
            label: "Entidad federativa",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "municipio_id",
            label: "Municipio",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "localidad_id",
            label: "Localidad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "colonia",
            label: "Colonia",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "vialidad_tipo_vial",
            label: "Tipo vialidad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "vialidad_nom_vial",
            label: "Nombre vialidad",
            tdClass: "text-left",
            formatter: 'emptyFields'
          },
          {
            key: "cp",
            label: "CP",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
          {
            key: "numExt",
            label: "Número exterior",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
          {
            key: "numInt",
            label: "Número interior",
            tdClass: "text-right",
            formatter: 'emptyFields'
          },
        ]
      };
    },
    computed: {
      ...mapFields(['ant_sub_12']),
      calculo1() {

        var a = parseInt(this.item_entes22.ant_sub_12);
        var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad);
        var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad);
        var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad);
        var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad);
        var g = parseInt(this.item_entes22.ant_otros_cantidad);

        var suma = b + c + d + e + g ;

        if (isNaN(suma)) {
          return 0
        }
        return suma
      },
      calculo2() {
        var a = parseInt(this.item_entes22.ant_sub_12);
        var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad);
        var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad);
        var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad);
        var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad);
        var g = parseInt(this.item_entes22.ant_otros_cantidad);

        var suma = a + b + c + d + e + g ;

        if (isNaN(suma)) {
          return 0
        }
        return suma
      },
      calculo3() {
        var suma = 0

        var a = parseInt(this.item_entes22.ant_sub_12);
        if (isNaN(a)) {
          a = 0;
        }
        var b = parseInt(this.item_entes22.ant_actividad_comercial_cantidad);
        if (isNaN(b)) {
          b = 0;
        }
        var c = parseInt(this.item_entes22.ant_actividad_financiera_cantidad);
        if (isNaN(c)) {
          c = 0;
        }
        var d = parseInt(this.item_entes22.ant_servicios_profecionales_cantidad);
        if (isNaN(d)) {
          d = 0;
        }
        var e = parseInt(this.item_entes22.ant_arrendamientos_cantidad);
        if (isNaN(e)) {
          e = 0;
        }
        var f = parseInt(this.item_entes22.ant_neto_conyugue_cantidad);
        if (isNaN(f)) {
          f = 0;
        }
        var g = parseInt(this.item_entes22.ant_otros_cantidad);
        if (isNaN(g)) {
          g = 0;
        }

        suma = a + b + c + d + e + f + g;


        // console.log(value);
        if (isNaN(suma)) {
          return 0
        }

        return suma

      },
      getSigno() {
        var signo = "$";
        var val = this.item_entes22.moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        });
        return signo;
      },
      getCodigoMoneda() {
        var codigo = "MXN";
        var val = this.item_entes22.moneda_id;
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            codigo = item.codigo;
          }
        });
        return codigo;
      },
    },
    watch: {

      list_entes: {
        handler: function () {
          if (this.list_entes) {
            this.setLocalidades();
            /* if (this.list_entes.length == 0) {
              this.item_entes22.bandera = '0';
            } else {
              this.item_entes22.bandera = '1';
            } */
          }
        },
        deep: true
      },
      n_domicilio: {
        handler: function () {
          if (this.n_domicilio) {
            this.item_entes22.pais_id = this.n_domicilio.pais_id ? this.n_domicilio.pais_id : 150;
            this.item_entes22.entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.item_entes22.municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.item_entes22.localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.item_entes22.cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.item_entes22.colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
            this.item_entes22.vialidad_tipo_vial = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.item_entes22.vialidad_nom_vial = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.item_entes22.numExt = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.item_entes22.numInt = this.n_domicilio.int ? this.n_domicilio.int : "";
          }
        },
        deep: true
      },
      'item_entes22.ant_sub_12': function () {
        this.calcula_totales2()
      },
      'item_entes22.ant_actividad_comercial_cantidad': function () {
        this.calcula_totales2()
      },
      'item_entes22.ant_actividad_financiera_cantidad': function () {
        this.calcula_totales2()
      },
      'item_entes22.ant_servicios_profecionales_cantidad': function () {
        this.calcula_totales2()
      },
      'item_entes22.ant_arrendamientos_cantidad': function () {
        this.calcula_totales2()
      },
      'item_entes22.ant_neto_declarante': function () {
        this.calcula_totales2()
      },
      'item_entes22.ant_neto_conyugue_cantidad': function () {
        this.calcula_totales2()
      },
    },
    methods: {
      getSignoDos(val = "97") {
        var signo = "$";
        this.monedas.forEach(function (item) {
          if (item.id == val) {
            signo = item.signo;
          }
        })
        return signo;
      },
      calcula_totales2(evt) {
        //alert("as")
        var sub12 = 0
        var sub22 = 0
        var unoydos2 = 0
        var segundasuma22 = 0

        sub12 = parseInt(this.item_entes22.ant_sub_12)
        sub22 = parseInt(this.item_entes22.ant_actividad_comercial_cantidad) + parseInt(this.item_entes22.ant_actividad_financiera_cantidad) + parseInt(this.item_entes22.ant_servicios_profecionales_cantidad) + parseInt(this.item_entes22.ant_arrendamientos_cantidad)
        unoydos2 = parseInt(sub12) + parseInt(sub22)
        this.item_entes22.ant_sub_22 = sub22
        this.item_entes22.ant_suma_12 = unoydos2
        this.suma3 = unoydos2
        //this.item_entes22.ant_neto_declarante = this.item_entes22.ant_suma_12
        //alert(sub2)
        segundasuma22 = parseInt(this.item_entes22.ant_neto_declarante) + parseInt(this.item_entes22.ant_neto_conyugue_cantidad)
        this.item_entes22.ant_suma_32 = segundasuma22

      },
      emptyFields(value) {
        if (value) {
          if (typeof value === 'string' || value instanceof String) {
            return value.toUpperCase();
          } else {
            return value;
          }
        } else {
          return '-';
        }
      },
      getTipoInstrumento() {
          var resp = " ";
          if (this.tipoinst) {
            this.tipoinst.forEach(function (item) {
              if (item.id == index) {
                resp = item.valor;
                return resp;
              }
            });
        }
        return resp;

      },
      initItem() {

      },
      showItem() {
        this.add_item = !this.add_item;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      addItem55() {
        if (this.item_entes22) {
          this.item_entes22.ip_id = this.ip_id;
          this.loadButton(this.$refs.btnSave);
          this.$http.post("sueldos_otros", this.item_entes22).then(
            response => {
              this.StepOk("Guardado");
              if (this.edit_item === undefined || this.edit_item === null) {
                this.item_entes22 = response.data.sueldos
                // this.list_entes.push({
                //...response.data.sueldo
                // });
              } else {
                this.list_entes.splice(
                  this.edit_item.index,
                  1,
                  this.item_entes22
                );
                this.edit_item.item._rowVariant = "";
              }
              this.showItem();
              this.initItem();
              this.edit_item = null;
            },
            error => {
              this.StepError(error);
              //this.change =  true;
            }
          );
        } else {
          this.StepW("Hay campos sin completar");
        }
        //console.log(this.item_entes22);
      },
      editItem(indice) {
        this.showItem();
        this.edit_item = indice;
        this.item_entes22 = {
          ...this.list_entes[this.edit_item.index]
        };
        this.editDomicilio();
        this.edit_item.item._rowVariant = "danger";
        $(".main-panel").animate({
            scrollTop: 100
          },
          500,
          "swing"
        );
      },
      removeItem(indice) {
        if (this.list_entes[indice].id !== null) {
          let item = this.list_entes[indice];
          //this.list_entes.splice(indice, 1);
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("sueldos_otros/" + item.id).then(
              response => {
                /* eventBus.$emit("TramiteDelete", item); */
                this.list_entes.splice(indice, 1);
              },
              error => {
                this.Err(error);
              }
            );
          });
        }
      },
      validate() {
        return this.$validator.validateAll()
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      editDomicilio() {
        this.n_domicilio.pais_id = this.item_entes22.pais_id ? this.item_entes22.pais_id : 150;
        this.n_domicilio.entidadF = this.item_entes22.entidad_federativa_id ? this.item_entes22.entidad_federativa_id : '';
        this.n_domicilio.municipio = this.item_entes22.municipio_id ? this.item_entes22.municipio_id : '';
        this.n_domicilio.localidad = this.item_entes22.localidad_id ? this.item_entes22.localidad_id : '';
        this.n_domicilio.cp = this.item_entes22.cp ? this.item_entes22.cp : '';
        this.n_domicilio.colonia = this.item_entes22.colonia ? this.item_entes22.colonia : '';
        this.n_domicilio.vialidad = this.item_entes22.vialidad_tipo_vial ? this.item_entes22.vialidad_tipo_vial : '';
        this.n_domicilio.vialidad_nombre = this.item_entes22.vialidad_nom_vial ? this.item_entes22.vialidad_nom_vial : '';
        this.n_domicilio.ext = this.item_entes22.numExt ? this.item_entes22.numExt : '';
        this.n_domicilio.int = this.item_entes22.numInt ? this.item_entes22.numInt : '';
      },

      setLocalidades() {
        this.localidades = [];
        this.list_entes.forEach((item) => {
          if (item.localidad_id) {
            this.$http.get('localidades/localidad/' + item.localidad_id).then(
              response => {
                this.localidades.push(response.data.localidad);
              },
              error => {
                this.Err(error);
              }
            );
          }
        });
      },
      isNumber(n) {
        //console.log(n);
        n.target.value = n.target.value.replace(/[^\d.-]/g, '');
      }
    },
    created() {
      // alert("asd")
      this.tipo = this.getKey('tipo_dec');
      this.ip_id = this.getId();
      this.initItem();
      //this.getLocalidades(97250);
      this.$http.get("sueldos_otros/" + this.ip_id).then(
        response => {
          if (response.data.respuesta.sueldos != null) {
            this.item_entes22 = response.data.respuesta.sueldos
            this.plantilla = response.data.respuesta.plantilla
            console.log(response.data.respuesta)

           if(Number(this.item_entes22.ant_sub_12)>0){
             this.item_entes22.bandera='1';
           }
          }
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_ente_publico").then(
        response => {
          this.entes = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );

      this.$http.get("cat_unidad_medida_plazo").then(
        response => {
          this.plazos = response.data.unidades;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_sector_industria").then(
        response => {
          this.sectores = response.data.sectores;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_tipo_actividad").then(
        response => {
          this.actividades = response.data.actividad;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("entidadFed").then(
        response => {
          this.entidadFed = response.data.entidadfed;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_tipo_instrumentos").then(
          response => {
            this.tipoinst = response.data.instrumentos;
          },
          error => {
            this.Err(error);
          }
      );
      this.$http.get("cat_tipo_bien_enajenacion").then(
          response => {
            this.tipobienen = response.data.bienes;
          },
          error => {
            this.Err(error);
          }
      );
      /*
      this.$http.get("paises").then(
        response => {
          this.paises = response.data.pais;
        },
        error => {
          this.Err(error);
        }
      );
      */
      this.$http.get("municipios").then(
        response => {
          this.municipios = response.data.municipios;
        },
        error => {
          this.Err(error);
        }
      );
        /*
        this.$http.get("monedas").then(
          response => {
            this.monedas = response.data.monedas;
            var temp = "97";
            this.monedas.forEach(function (item) {
              if (item.codigo == "MXN") {
                temp = item.id;
              }
            });
            this.item_entes22.moneda_id = temp;
          },
          error => {
            this.Err(error);
          }
        );
        */
    },
    filters: {
      formatPrice: function (value) {
        let val = (value / 1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    },
  };

</script>
<style>
  .has-error .form-control,
  .form-control.error,
  .form-control[aria-invalid="true"] {
    color: #66615b !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Ingresos/SueldosSalariosOtros.vue